// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Translation
import { FormattedMessage } from 'react-intl';

// Style
import { Button, Modal } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import { closeThankYouModal } from '../../actions/modalActions';
// Locale
import messages from '../../locale/jsonMessages';

import cs from '../../components/commonStyle.css';
import s from './ThankYouModal.css';

const ThankYouModal = () => {

    const dispatch = useDispatch();
    const thankYouModal = useSelector(state => state.modalStatus.isThankYouModalOpen);

    return (
        <Modal show={thankYouModal} animation={false} onHide={() => dispatch(closeThankYouModal())}
            dialogClassName={cx('commonModalContainer', 'globalModalContainer')} >
            <Modal.Header closeButton className='commonModalHeader'>
                <Modal.Title className='commonModalTitle'><FormattedMessage {...messages.thankyouTitle} /></Modal.Title>
            </Modal.Header>
            <Modal.Body bsClass='commonModalBody'>
                <p className={cs.commonMediumText}> <FormattedMessage {...messages.thankyouInfo1} /></p>
                <Button className={cx(cs.btnPrimary, cs.spaceTop3)} block type="submit" onClick={() => dispatch(closeThankYouModal())}>
                    <FormattedMessage {...messages.close} />
                </Button>
            </Modal.Body>
        </Modal>
    );
}

ThankYouModal.propTypes = {
    closeLoginModal: PropTypes.any,
    reportModal: PropTypes.bool,
    closeReportUserModal: PropTypes.any,
    formatMessage: PropTypes.any,
};

export default withStyles(cs, s)(ThankYouModal);